@let profile = profile$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Property Profile</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>This Property</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="tw:flex tw:justify-between tw:align-middle">
        <div>
          <div class="tw:text-lg tw:font-bold">{{profile | redAddress:addressType.LineOne}}</div>
          <div class="tw:text-lg tw:font-bold">{{profile | redAddress:addressType.LineTwo}}</div>
          <div class="tw:pt-2 tw:text-sm"><ion-text color="medium">Parcel Number:</ion-text></div>
          <div class="tw:text-md tw:font-bold">{{profile?.APN | redDashIfEmpty}}</div>
          <div class="tw:pt-2 tw:text-sm">Owner:</div>
          <div class="tw:text-md tw:font-bold">{{profile?.PrimaryOwnerName | redDashIfEmpty }}</div>
          @if (profile?.SecondaryOwnerName) {
          <div class="tw:text-xs tw:font-bold">{{profile?.SecondaryOwnerName | redDashIfEmpty }}</div>
          }
        </div>
      </div>

      <ion-grid class="ion-no-padding tw:mt-4">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:pt-2 tw:text-sm">Last Selling Price:</div>
            <div class="tw:text-lg tw:font-bold">{{profile?.SalesPrice | redCurrency }}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:justify-end">
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bedroom.svg" size="large"></ion-icon>
              <div>{{profile?.Bedrooms | redDashIfEmpty}} Bed</div>
            </div>
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bathroom.svg" size="large"></ion-icon>
              <div>{{profile?.Baths | redDashIfEmpty}} BA</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Area Sales</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:pt-2 tw:text-sm">Price:</div>
            <div class="tw:text-lg tw:font-bold">{{profile?.AreaSales?.MedianValue | redCurrency}}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:justify-end">
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bedroom.svg" size="large"></ion-icon>
              <div>{{profile?.AreaSales?.MedianNumBeds | redDashIfEmpty}} Bed</div>
            </div>
            <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
              <ion-icon src="/assets/svg/bathroom.svg" size="large"></ion-icon>
              <div>{{profile?.AreaSales?.MedianNumBaths | redDashIfEmpty}} BA</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <ion-button routerLink="{{defaultBackHref}}/profile/{{profileId}}/report" class="tw:m-4" expand="block">
    <ion-icon slot="end" name="create-outline"></ion-icon>
    Property Report
  </ion-button>

  <ion-grid class="tw:m-4">
    <ion-row>
      @if (orderTitleEnabled$ | async) {
      <ion-col size="6" (click)="orderTitle()">
        <div class="tw:flex tw:flex-col tw:items-center">
          <ion-button shape="round" fill="solid" size="large">
            <ion-icon slot="icon-only" src="/assets/svg/order-title.svg"></ion-icon>
          </ion-button>
          <ion-text color="primary">Order Title</ion-text>
        </div>
      </ion-col>
      } @if (walkingFarmEnabled$ | async) {
      <ion-col size="6">
        <div class="tw:flex tw:flex-col tw:items-center">
          <ion-button shape="round" fill="solid" size="large" (click)="fastFarm()">
            <ion-icon slot="icon-only" src="/assets/svg/fast-farm.svg"></ion-icon>
          </ion-button>
          <ion-text color="primary">Fast Farm</ion-text>
        </div>
      </ion-col>
      } @if ((calculatorsEnabled$ | async) || (netSheetEnabled$ | async)) {
      <ion-col size="6">
        <div class="tw:flex tw:flex-col tw:items-center">
          @if (netSheetEnabled$ | async) {
          <ion-button
            routerLink="{{defaultBackHref}}/profile/{{profileId}}/net-sheet"
            shape="round"
            fill="solid"
            size="large"
            (click)="prefillNetSheet()"
          >
            <ion-icon slot="icon-only" src="/assets/svg/net-sheet-inactive.svg"></ion-icon>
          </ion-button>
          <ion-text color="primary">Net Sheet</ion-text>
          } @else {
          <ion-button
            routerLink="{{defaultBackHref}}/profile/{{profileId}}/piti"
            shape="round"
            fill="solid"
            size="large"
          >
            <ion-icon slot="icon-only" src="/assets/svg/piti.svg"></ion-icon>
          </ion-button>
          <ion-text color="primary">PITI Calculator</ion-text>
          }
        </div>
      </ion-col>
      }
      <ion-col size="6" (click)="getDirections()">
        <div class="tw:flex tw:flex-col tw:items-center">
          <ion-button shape="round" fill="solid" size="large">
            <ion-icon slot="icon-only" src="/assets/svg/directions.svg"></ion-icon>
          </ion-button>
          <ion-text color="primary">Directions</ion-text>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item [button]="true" routerLink="{{defaultBackHref}}/profile/{{profileId}}/details">
      <ion-icon slot="start" name="list-circle-outline"></ion-icon>
      <ion-label>Details & Characteristics</ion-label>
    </ion-item>
    @if (transactionHistoryEnabled$ | async) {
    <ion-item
      [detail]="(profile?.TransHistory ?? []).length > 0"
      routerLink="{{defaultBackHref}}/profile/{{profileId}}/transaction-history"
      [disabled]="!profile?.TransHistory?.length"
    >
      <ion-icon slot="start" name="time-outline"></ion-icon>
      <ion-label>Transaction History</ion-label>
      @if (profile?.TransHistory?.length) {
      <ion-note slot="end"> {{profile?.TransHistory?.length}} </ion-note>
      } @if (!profile?.TransHistory?.length) {
      <ion-badge slot="end">Unavailable</ion-badge>
      }
    </ion-item>
    } @if (saleInformationEnabled$ | async) {
    <ion-item [button]="true" routerLink="{{defaultBackHref}}/profile/{{profileId}}/sale-information">
      <ion-icon slot="start" src="/assets/svg/sale-information.svg"></ion-icon>
      <ion-label>Sale Information</ion-label>
    </ion-item>
    } @if (schoolDistrictInfo$ | async) {
    <ion-item
      [disabled]="(hasSchoolsData$ | async) === false"
      [detail]="(hasSchoolsData$ | async) === true"
      routerLink="{{defaultBackHref}}/profile/{{profileId}}/schools"
    >
      <ion-icon slot="start" name="school-outline"></ion-icon>
      <ion-label>Schools</ion-label>
      @if ((hasSchoolsData$ | async) === false) {
      <ion-badge slot="end">Unavailable</ion-badge>
      }
    </ion-item>
    }
    <ion-item [button]="true" routerLink="{{defaultBackHref}}/profile/{{profileId}}/map-view">
      <ion-icon slot="start" name="map-outline"></ion-icon>
      <ion-label>Map View</ion-label>
    </ion-item>

    <ion-item [disabled]="!isPlatMapAvailable" [button]="isPlatMapAvailable" (click)="getPlatMap()">
      <ion-icon slot="start" src="/assets/svg/plat-map.svg"></ion-icon>
      <ion-label>{{ isPlatMapViewable ? 'View Plat Map' : 'Email Plat Map' }}</ion-label>
      @if (!isPlatMapAvailable) {
      <ion-badge slot="end">Unavailable</ion-badge>
      }
    </ion-item>
  </ion-list>
</red-page-content>
